module.exports = __webpack_public_path__ + "static/media/frhlepIcon.624fc8fa.png";